import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { VolumeCarousel } from './components/VolumeCarousel';
import { Tomes } from './components/Tomes';
import { Testimonials } from './components/Testimonials';
import { voices } from './data/testimonials';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { UseCases } from './components/UseCases';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';

/** DPS46 · Breathwork Session Ready. */
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-ochre selection:text-ink" data-id="element-0" data-mp="3mkrdnl64zhdb">
      <MetaPixel data-id="element-1" data-mp="3rdaquh0wwahl" />
      <main data-id="element-2" data-mp="3rcsy3udgkeef">
        <Hero data-id="element-3" data-mp="3rd191gq0t9mz" />
        <SocialProofBar data-id="element-4" data-mp="3relu8fqg3g86" />
        <PainGrid data-id="element-5" data-mp="6hqtghuuhen" />
        <ProductReveal data-id="element-6" data-mp="4wvhonpuufq" />
        <VolumeCarousel data-id="element-7" data-mp="5ggxfcks0yi" />
        <Tomes data-id="element-8" data-mp="7ssnarqpf34" />
        <Testimonials voices={voices} data-id="element-9" data-mp="2zld0l5ad579f" />
        <Bonuses data-id="element-10" data-mp="2zmeoiach9o8k" />
        <ValueStack data-id="element-11" data-mp="2zmwit1fkxsdu" />
        <Urgency data-id="element-12" data-mp="2zng2amkvootz" />
        <Pricing data-id="element-13" data-mp="33mf0loc3tncg" />
        <Guarantee data-id="element-14" data-mp="33lx02fiesmyq" />
        <Faq data-id="element-15" data-mp="33nghwajpr62m" />
        <UseCases data-id="element-16" data-mp="33mykhalbelt4" />
        <CostOfInaction data-id="element-17" data-mp="33oi1x4ipj2wh" />
        <Close data-id="element-18" data-mp="38l8iru2c62iy" />
      </main>
      <Footer data-id="element-19" data-mp="38l053zye2t6p" />
      <PurchaseNotifications data-id="element-20" data-mp="38k6x6vnp1xmz" />
    </div>;
}